<template lang='pug'>
.content
  grid(
  name='',
  label='Cost Center'
  desc=''
  :views='false'
  layout='frame'
  search=true
  resizing=false
  :endpoint='api.$.BUAndCC.getCostCenters'
  :actions='actions'
  @removeRow='removeCC'
  @removeRows='removeCCs'
  @changeRow='editCC'
  remove-many
  ref='CostCentersGrid'
  fit-columns
  editable
)
    span(slot='additionalButtons')
      ed-button.btn.btn-actionbar(
        @click="addCC") Add CC

</template>
<script>
import Grid from '@/components/Grid'
import {remove} from '@/components/Grid/cells/actions'
import model from './model'
import { EventBus } from '@/event-bus'
import events from '@/core/events/events'

export default {
  components: {
    Grid
  },

  data() {
    return {
      model,
      actions: [remove]
    }
  },

  created() {
    EventBus.$on(events.BU_CC.REFRESH, r => {
      this.refresh()
    })
  },
  methods: {
    editCC (payload, success, fail) {
      //
      if (!this.validCC(payload.data)) {
        fail('Invalid Cost Center')
      } else {
        this.api.post(this.api.$.BUAndCC.saveCostCenter, payload.data)
          .then(r => success(r))
          .catch(e => fail())
      }
    },

    removeCC(payload, success, fail) {
      //
      var id = +payload.data.CostCenterId
      this.api.delete(this.api.$.BUAndCC.deleteCostCenter + '/' + id, id)
        .then(r => success())
        .catch(e => fail('Something went wrong. Cannot delete the Cost Center'))
    },

    removeCCs (payload) {
      //
      var costCentersIds = []
      payload.rows.forEach(element => {
        costCentersIds.push(element.data.CostCenterId)
      })
      var p = {
        IDs: costCentersIds
      }
      this.api.post(this.api.$.BUAndCC.deleteCostCenters, p).then(this.validateDeleteCCs)
    },

    validCC(data) {
      var isValid = false
      if (data.CostCenterNo && data.CostCenterNo.trim() !== '') {
        isValid = true
      }
      return isValid
    },

    addCC() {
      this.$refs.CostCentersGrid.addRow({})
    },

    refresh() {
      this.$refs.CostCentersGrid.quickSearch()
      this.$refs.CostCentersGrid.onSelectAll(false)
    },

    validateDeleteCCs(r) {
      if (r.data.Errors.length !== 0) {
        alert('Something went wrong. Cannot delete the Cost Centers.')
      }
      EventBus.$emit(events.BU_CC.REFRESH)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/_modules/BusinessUnitsAndCostCenters/CC-list/index.vue